import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import MainMenu from '../layout/Sidebar';
import Menu from '../layout/Menu';
import { connect } from 'react-redux';
import UserNav from '../layout/UserNav';
import Spinner from '../layout/Spinner';
import { getCompanyProfiles } from '../../actions/profile';
import { getUserCompany } from '../../actions/company';
import { getPlanSettings } from '../../actions/plan';
import { getCompanyPlanAnswers, } from '../../actions/planAnswer';
import { getAllCustoms, getCustomSettings } from '../../actions/custom';
import SubMenu from '../elems/SubMenu';
import Table from './Table';
import { setAlert } from '../../actions/alert';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';
import { menuTitle, menuItems, tableNameTitle, tableTitleItems, getCheckinsMenuNew, } from '../../utils/menu/dashboard';
import NotificationCheckin from '../utils/new/NotificationCheckin';
import WidgetsDashboard from '../widgets/new/Widgets';
import NotificationIcebreaker from '../utils/new/NotificationIcebreaker';
import { getIcebreakers, addIcebreakerAnswer } from '../../actions/icebreaker';
import { getUpdates } from '../../actions/update';
import { getUserUpdateAnswers } from '../../actions/updateAnswer';
import { getUserAnswers } from '../../actions/standupAnswer';
import { getStandups } from '../../actions/standup';
import { checkinCopy } from '../../utils/wording/checkins';
import { updateCopy } from '../../utils/wording/updates';
import { planCopy } from '../../utils/wording/plans';
import { copy } from '../../utils/wording/customs';
import { icons } from "../../img/elements/icons";
import NotAnsweredTable from './NotAnsweredTable';
import { Link } from 'react-router-dom';
import PlanItemCard from '../plans/new/PlanItemCard';  
// import PlanItemCard from '../customAnswers/CustomItemCard';  
import { getCompanyCustomAnswersById } from '../../actions/customAnswer';


const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontSize: '14px',
  }),
  input: () => ({
    backgroundColor: '#fcfcfd',
    fontSize: '14px',
  }),
  control: styles => ({ ...styles, backgroundColor: '#fcfcfd', padding: '4px 8px' }),
  placeholder: styles => ({ ...styles, fontSize: '14px' }),
  singleValue: (provided, state) => {
    const fontSize = '14px';

    return { ...provided, fontSize };
  }
}

let iteration = 0;

const DashboardCustoms = ({
  getCompanyPlanAnswers,
  getUserCompany,
  getCompanyProfiles,
  planAnswer: { planAnswers, planAnswer },
  auth: { user, sidebar },
  company: { company },
  profile: { profiles },
  locale,
  getPlanSettings,
  plan: { settings },
  getAllCustoms,
  custom,
  updateAnswer: { updateAnswers },
  getUpdates,
  update: { updates },   
  getUserUpdateAnswers,
  getIcebreakers,
  icebreaker: { icebreakers },
  addIcebreakerAnswer,
  standupAnswer: { standupAnswers },
  getUserAnswers,
  getStandups,
  standup: { standups },
  customAnswer: { customAnswers, customAnswer, loading },
  getCompanyCustomAnswersById,
  getCustomSettings,
  match,
}) => {
const [formData, setFormData] = useState({
    team: '',
    answers: [],
    notCompletedAnswers: [],
    campaigns: 0,     // старое решение пока оставил, но тут мы угадываем цифру
    campaignsArr: [], // помещаем сюда settings.pastEvents, чтобы считать реальные события
    time: '',
    lastFiveAnswers: [],
    userAnswers: [],
  });

  // ToDo: поместить в campaigns то, что сейчас хранится в campaignsArr 
  // Надо сделать перерасчет в виджет на основе arr.length, а не цифры campaigns

  const [menuData, setMenu] = useState({
    menu: {},
    menuIndex: [],
    showIcebreaker: false
  });

  let { menu, showIcebreaker, menuIndex } = menuData;
  const [usersAmount, setUsersAmount] = useState(0);
  let { team, answers, notCompletedAnswers, time, campaigns, campaignsArr, lastFiveAnswers, userAnswers} = formData;
  let teamOptions = [];
  let timeOptions = [];

  const getMenuIndex = campaigns => {
    // console.log('======= campaigns in getMenuIndex', campaigns)
    let arr = campaigns.map((item, index) => {
      if (item._id === match.params.id) {
          // return index + 5;
          return index + 1;
        }
    })

    let index = arr.filter(item => item !== undefined)[0];

    return index;
  };

  // Перебор profiles & departments и приведение данных к формату Селекта
   {
    profiles &&
      profiles.forEach((profile, index) => {
        
        if (user && profile._id === user._id) return;  // return = continue in forEach

        let coworker = {
          value: profile._id,
          label: `${profile.firstName} ${profile.lastName}`,
          type: 3
        };

        teamOptions.push(coworker);
      });
  }

  {
    company && company.departments.length > 0 &&
      company.departments.forEach((department, index) => {

        if (user && user.department === null) {
          let team = {
            value: department._id,
            label: department.name,
            type: 2
          };
  
          teamOptions.unshift(team);
        } else if (user && user.department !== null && user.department !== undefined && department._id !== user.department) {
          let team = {
            value: department._id,
            label: department.name,
            type: 2
          };
  
          teamOptions.unshift(team);
        }

        if (user && index === company.departments.length - 1) {

          // You is third in list
          let person = { value: user._id, label: `${user.firstName} ${user.lastName}`, type: 3 }
          teamOptions.unshift(person);

          // Second option is the team if exists
          if (user.department !== null && user.department !== undefined) {
            let team = { value: user.department, label: `😎 ${user.departmentName}`, type: 2 };
            teamOptions.unshift(team);
          }

          // Third option is the company
          let name = { value: company._id, label: `💪 ${company.name}`, type: 1 };
          teamOptions.unshift(name);
        }
      });
  } 

  if (company && company.departments.length === 0 && user && profiles && profiles.length === 1) {
    teamOptions = [
      { value: company._id, label: `💪 ${company.name}`, type: 1 },
      { value: user._id, label: `${user.firstName} ${user.lastName}`, type: 3 }
    ]
  } else if (company && company.departments.length === 0 && user && profiles && profiles.length > 1) {
    // if 0 teams and 1+ users
    // add user and company to others members that we found in the profiles loop
      let person = { value: user._id, label: `${user.firstName} ${user.lastName}`, type: 3 }
      teamOptions.unshift(person);

      let team = { value: company._id, label: `💪 ${company.name}`, type: 1 };
      teamOptions.unshift(team);
  }

  let choosedTeam = company ? { value: company._id, label: `💪 ${company.name}`, type: 1 } : {};

  // Time Options
  let hours = new Date().getUTCHours();
  let minutes = new Date().getMinutes();
  let today = new Date().getDay();
  let midnight = new Date().setHours(0,0,0,0);
  if (today === 0) { today = 8 }; // For Sundays

  let all = Date.parse(new Date(new Date(2019, 1, 1, 1, 1)));
  let quarter = Date.parse(new Date(new Date() - (90 * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60) * 1000));
  let month = Date.parse(new Date(new Date() - (30 * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60) * 1000));
  let weekAgo = Date.parse(new Date(new Date() - (7 * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60) * 1000));
  let thisWeek = Date.parse(new Date(new Date() - ((today - 1) * 60 * 60 * 24 + hours * 60 * 60 + minutes * 60) * 1000));
  let allTime = locale && locale.lang !== 'ru' ? `All Time` : `Все время`; 
  let quarterTime = locale && locale.lang !== 'ru' ? `Quarter` : `Квартал`; 
  let monthTime = locale && locale.lang !== 'ru' ? `Last month` : `Месяц`; 
  let weekTime = locale && locale.lang !== 'ru' ? `Last 7 days` : `7 дней`; 
  let thisWeekTime = locale && locale.lang !== 'ru' ? `This week` : `Эта неделя`; 
  let todayTime = locale && locale.lang !== 'ru' ? `Today` : `Сегодня`; 

  timeOptions = [
      { value: 5, label: allTime, period: all },
      { value: 4, label: quarterTime, period: quarter },
      { value: 3, label: monthTime, period: month },
      { value: 2, label: weekTime, period: weekAgo },
      { value: 1, label: thisWeekTime, period: thisWeek },
      { value: 7, label: todayTime, period: midnight },
    ];

  let choosedTime = { value: 2, label: weekTime, period: weekAgo };

  // Get users who don't post answers
  const getUnFinishedUsers = (profiles, answers, team) => {
 
    // Company mode by default
    let users = profiles;

    if (profiles.length > 0 && team && team.value) {
      if (team.type === 2) {
        // Team
        users = profiles.filter(item => item.department && item.department.toString() === team.value.toString());
      } else if (team.type === 3) {
        // User
        users = profiles.filter(item => item._id.toString() === team.value.toString());
      }
    }

    setUsersAmount(users.length);
    
    const unFinishedUsers = users.filter(({ _id: id1 }) => !answers.some(({ user: id2 }) => id2 && id2.toString() === id1.toString()));
    
    return unFinishedUsers;
  };

  useEffect(() => {
    // console.log('===== USEEFFECT 1 WORKS')

    if (iteration < 2) {
      getUserCompany();
      getCompanyProfiles();
      getAllCustoms();
    }

      getCompanyCustomAnswersById(match.params.id);
      getCustomSettings(match.params.id);
   
    setFormData({
      ...formData,
      team: !user ? '' : choosedTeam,
      answers: !customAnswers ? [] : customAnswers.filter(item => Date.parse(item.date) > midnight),
      notCompletedAnswers: !customAnswers && !profiles ? [] : getUnFinishedUsers(profiles, customAnswers.filter(item => Date.parse(item.date) > midnight), choosedTeam),
      time: !user ? '' : choosedTime,
      campaigns: !custom.settings ? 0 : 1,
      campaignsArr: custom && custom.settings && custom.settings.pastEvents ? custom.settings.pastEvents.filter(item => Date.parse(item.date) > midnight) : [],
      lastFiveAnswers: !customAnswers ? [] : customAnswers.slice(0, 5),
      userAnswers: !user || !customAnswers ? [] : customAnswers.filter(item => item.user && user._id && item.user.toString() === user._id.toString()),
    });

    setUsersAmount(!profiles ? 0 : profiles.length);

    let settingsArr = custom.campaigns && custom.campaigns.length > 0 && user && company ? getCheckinsMenuNew(custom.campaigns, company, user) : { menuArr: [menuItems[0]] };
    // console.log('======= settingsArr', settingsArr)
    // console.log('======= menuItems', menuItems)

    setMenu({
      // menu: custom.campaigns && custom.campaigns.length > 0 ? getCheckinsMenuNew(custom.campaigns, company, user) : menuItems,
      menu: settingsArr,
      // menuIndex: custom.campaigns && custom.campaigns.length > 0 ? getMenuIndex(custom.campaigns) : 100
      menuIndex: custom.campaigns && custom.campaigns.length > 0 ? getMenuIndex(settingsArr.menuArr) : 100
    });

  }, [
    match && match.params && match.params.id,
    getUserCompany, 
    getCustomSettings, 
    getCompanyProfiles,
    // loading, 
    getCompanyCustomAnswersById, 
    JSON.stringify(customAnswers),
    getAllCustoms,
    user,
  ]);

  iteration += 1;

  // console.log('===== menu', menu)
  // menu && console.log('===== menu.menuArr', menu.menuArr)
  // console.log('===== iteration', iteration)

  useEffect(() => {
    // console.log('===== USEEFFECT 2 WORKS')

    getUpdates(); 
    getStandups(); 
    getUserAnswers();
    getUserUpdateAnswers();
    getIcebreakers();

  }, [
    getUserUpdateAnswers,
    getUpdates, 
    getStandups,
    getIcebreakers, 
    getUserAnswers,
  ]);

  // Get users who don't post answers
  const getAnswers = (teamOption, time) => {

    let teamIndex = 'company';
    if (teamOption.type === 1) { teamIndex = 'company'; }
    if (teamOption.type === 2) { teamIndex = 'department'; }
    if (teamOption.type === 3) { teamIndex = 'user'; }

    const answersArr = customAnswers.filter(answer => answer[teamIndex] === teamOption.value && Date.parse(answer.date) > time.period);
    
    return answersArr;
  };

  // Get checkins number
  const getPastCheckins = (timeOption) => {

    let timeFilter = timeOption === 1 ? thisWeek : timeOption === 2 ? weekAgo : timeOption === 3 ? month : timeOption === 4 ? quarter : timeOption === 7 ? midnight : all;

    let pastEvents = custom.settings.pastEvents && custom.settings.pastEvents.length > 0 ? custom.settings.pastEvents.filter(e => Date.parse(e.date) > timeFilter) : [];

    return pastEvents.length;
  };

  // UNIQUE for Plans because we don't have standups or updates => only settings
  // Get planID number who don't post answers 
  // ДЕЛАЕМ примерную прикидку, сколько могло быть планов, так как у нас есть только planID и мы не создаем plan каждый раз, как standups
  // Работаем неправильно, так какпо факту мы предполагаем и НЕ учитываем А БЫЛи ЛИ реально созданы эти кампании 
  // Надо записывать кампанию в массив с указанием номер и даты 
  const getCustomNumber = (time) => {

    // All time by default
    let itemNumber = custom.settings.customID;
    let date = new Date();
    let weekday = date.getDay();
    let todayDate = date.getDate();

    // From time options
    // 1- this week, 2 - week ago, 3 - month, 4 - quarter,  7 - today, 
    if (time.value === 1) {
      if (custom.settings.interval !== 'Daily') {
        // itemNumber = getToday(weekday, custom.settings.scheduleDay.index, todayDate);
        itemNumber = getPastCheckins(time.value);
      } else {
        // Daily
       itemNumber = weekday;
      }
    };
    if (time.value === 2) {
      if (custom.settings.interval !== 'Daily') {
          // itemNumber = getToday(weekday, custom.settings.scheduleDay.index, todayDate);
          itemNumber = getPastCheckins(time.value);
      } else {
          // Daily
        itemNumber = 5;
      }
    };
    if (time.value === 3) {
      if (custom.settings.interval === 'Daily') { itemNumber = 20; };
      if (custom.settings.interval === 'Weekly') { itemNumber = 4; };
      if (custom.settings.interval === 'Biweekly') { itemNumber = 2; };
      if (custom.settings.interval === 'Monthly') { itemNumber = 1; };
    };
    if (time.value === 4) {
      if (custom.settings.interval === 'Daily') { itemNumber = 60; };
      if (custom.settings.interval === 'Weekly') { itemNumber = 12; };
      if (custom.settings.interval === 'Biweekly') { itemNumber = 6; };
      if (custom.settings.interval === 'Monthly') { itemNumber = 3; };
      };
    if (time.value === 7) {
        if (custom.settings.interval !== 'Daily') {
          // itemNumber = getToday(weekday, custom.settings.scheduleDay.index, todayDate);
          itemNumber = getPastCheckins(time.value);
      } else {
          // Daily
        itemNumber =  custom.settings.active ? 1 : 0;
      }
      };

    if (itemNumber < 0) { itemNumber = 0 }
    if (itemNumber > custom.settings.customID) { itemNumber = custom.settings.customID }

    return itemNumber;
  };

  const handleTime = async selectedOption => {
    try {
      let newItems = [];
      let newCompletedItems = [];
      let newNotCompletedItems = [];
      let newCampaigns = [];
      let newCampaignsArr = [];

      newItems = await getAnswers(team, selectedOption);
      newNotCompletedItems = await getUnFinishedUsers(profiles, newItems, team);
      newCampaigns = await getCustomNumber(selectedOption);
      newCampaignsArr = custom.settings.pastEvents.filter(item => Date.parse(item.date) > selectedOption.period); 
     
      setFormData({ 
        ...formData, 
        time: selectedOption, 
        answers: newItems,
        notCompletedAnswers: newNotCompletedItems,
        campaigns: newCampaigns,
        campaignsArr: newCampaignsArr,
        lastFiveAnswers: newItems.slice(0, 5),
      });
    } catch (err) {

      setAlert(
        <FormattedMessage
          id="like.alert.error"
          defaultMessage="Something went wrong. We are working on it..."
        />,
        'danger'
      );
      console.log('Error in handleTime', err);
    }
  };

  const handleTeam = async selectedOption => {
    try {
      let newItems = [];
      let newNotCompletedItems = [];
      newItems = await getAnswers(selectedOption, time);
      newNotCompletedItems = await getUnFinishedUsers(profiles, newItems, selectedOption);
      
      setFormData({ 
        ...formData, 
        team: selectedOption, 
        answers: newItems,
        notCompletedAnswers: newNotCompletedItems,
        lastFiveAnswers: newItems.slice(0, 5),
      });
    } catch (err) {

      setAlert(
        <FormattedMessage
          id="like.alert.error"
          defaultMessage="Something went wrong. We are working on it..."
        />,
        'danger'
      );
      console.log('Error in handleTeam', err);
    }
  };

  // Get users who don't post answers
  const getUserAnswersAmount = (id) => {

    const answersAmount = answers.filter(answer => answer.user && answer.user.toString() === id.toString());
    
    return answersAmount;
  };

  // Removing duplicates in answers array based on the object key 'update' - to send only unique update items to updateTeamItem
  // Берем данные из стейта checkins, а не редакса planAnswers, чтобы делать фильтр на странице
  let uniqueAnswers = answers ? (answers.reduce((acc, current) => {
    const x = acc.find(item => item.user === current.user);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, [])) : [];

  // Calculate Data
  let campaignsTitle = <FormattedMessage id="total.checkins" defaultMessage="Total Check-ins"/>;
  let completedAnswersTitle = <FormattedMessage id="answers" defaultMessage="Answers"/>;
  let notCompletedAnswersTitle = <FormattedMessage id="not.answered" defaultMessage="Not answered"/>;
  let answersPercentTitle = <FormattedMessage id="answers.percent" defaultMessage="Percent of answers"/>;
  let noAnswersUsersTitle = <FormattedMessage id="users.noAnswer" defaultMessage="Users who didn't answer"/>;
 
  // Data for 4 widgets (campaigns without length)
  let percent = (answers.length / (usersAmount * campaigns)) * 100;
  let answersPercent = Math.round(percent);
  let unfinished = campaigns * usersAmount - answers.length;
  
  if (campaigns.length === 0 && answers.length === 0 || unfinished < 0 || isNaN(percent)) {
    unfinished = 0;
    answersPercent = 0;
  }
  
  // Create array with data for widgets
  const firstWidget = {
    data: campaignsArr && campaignsArr.length,
    title: campaignsTitle
  };
  const secondWidget = {
    data: answers.length,
    title: completedAnswersTitle,
  };
  const thirdWidget = {
    data: unfinished,
    title: notCompletedAnswersTitle,
  };
  const forthWidget = {
    data: `${answersPercent}%`,
    title: answersPercentTitle
  };

  const widgetData = [firstWidget, secondWidget, thirdWidget, forthWidget];

  let noAnswersMsg = <FormattedMessage id="no.answers" defaultMessage={`No answers`} />;
  let everyoneAnsweredMsg = <FormattedMessage id="all.answered" defaultMessage={`Everyone answered`} />;
  let subTitle = <FormattedMessage id="dashboard.okrs.subtitle" defaultMessage="Align your team around objectives to achieve better results." />
  let latestCheckins = <FormattedMessage id="latest.checkins" defaultMessage="Latest Check-ins" />
  let viewCheckins = <FormattedMessage id="view.checkins" defaultMessage="View All Check-ins" />;
  
  let customTxt = custom && custom.settings && custom.settings.name ? custom.settings.name : 'Check-in';
  const noAccess = <FormattedMessage id="checkin.noaccess" defaultMessage="You don't have access to this check-in" />;
  
  // customAnswer ? console.log('====== customAnswer.customID', customAnswer.customID) : console.log('====== customAnswer', customAnswer)
  // custom && custom.settings ? console.log('====== custom.settings.customID', custom.settings.customID) : console.log('====== custom', custom)
  // customAnswer && custom && custom.settings && console.log('====== customAnswer.customID !== custom.settings.customID', customAnswer.customID !== custom.settings.customID)
  
  return (
    <Fragment>
      <div className="css-main bg-primary">
        <div className="wrapper">

        {/* {user && user.department ? (
          <Menu companyName={user && user.companyName}   team={user.departmentName} teamId={user.department} settings={user.isAdmin && true} focusUsers={user && user.isAdmin && user.role === 'Superadmin' && true} activeIndex={13} />
        ) : (
          <Menu companyName={user && user.companyName}   settings={user && user.isAdmin && true} focusUsers={user && user.isAdmin && user.role === 'Superadmin' && true} activeIndex={13} />
        )} */}

        {user && !loading && (
          <MainMenu activeIndex={13} />
        )}

        <UserNav />
        
          <Fragment>
            {loading || !user || !company || !custom || !customAnswers ? (
              <Spinner />
            ) : (
              <Fragment>
                <div className={`${sidebar === 1 ? 'ml-280-xxl main main-dashboard ' : 'short_menu__ml pl-5 ma-w90'} main_new mt-3`}>
                  <div className="page-title">
                    <h5 className="pl-0-xs">{menuTitle}</h5>
                    <p className="medium">{subTitle}</p>
                  </div>

                  <div className="insights mt-3">
                    <div className="notifications flex align-center pb-3">
                      {standups && standupAnswers.length === 0 && standups.length > 0 ||
                        standups && standupAnswers &&
                        standupAnswers.length > 0 && standups.length > 0 &&
                        standups[0]._id.toString() !== standupAnswers[0].standup.toString() && 
                        (
                          <NotificationCheckin
                            msg={checkinCopy.standupLiveNew}
                            type={1}
                            cta={checkinCopy.standupLiveCtaNew}
                            icon={icons.light_bulb}
                            btnColor={'blue'}
                            color={`blue`}
                            url={standups && standups.length > 0 ? `/checkins/${standups[0]._id}` : '/checkins'}
                            styles={'mr-25'}
                          />
                        )
                      }

                      {planAnswers.length === 0 && settings && settings.active ||
                        planAnswer && settings && settings.active && planAnswer.planID !== settings.planID ? (
                          <NotificationCheckin
                            msg={planCopy.planLiveNew}
                            // msg2={msgHelloUser2}
                            cta={planCopy.planLiveCtaNew}
                            type={3}
                            icon={icons.clipboard}
                            btnColor={'yellow'}
                            color={`yellow`}
                            url={`/plans/complete`}
                            styles={'mr-25'}
                          />
                        ) : null}

                      {updates && updateAnswers.length === 0 && updates.length > 0 ||
                      updates && updateAnswers.length > 0 && updates.length > 0 &&
                      updates[0]._id.toString() !== updateAnswers[0].update.toString() && 
                        (
                          <NotificationCheckin
                            msg={updateCopy.updateLiveNew}
                            type={2}
                            cta={updateCopy.updateLiveCtaNew}
                            icon={icons.clipboard}
                            btnColor={'green'}
                            color={`green`}
                            url={updates.length > 0 ? `/updates/${updates[0]._id}` : '/updates'}
                            styles={'mr-25'}
                          />
                        )}

                      {customAnswers.length === 0 && custom.settings && custom.settings.active ||
                        customAnswer && custom.settings && custom.settings.active && customAnswer.customID !== custom.settings.customID ||
                        !customAnswer && custom.settings ? (
                          <Fragment>
                            {user && user.isAdmin || custom.settings.visibility.value === 1
                              || custom.settings.visibility.value === 2 && user.department && custom.settings.team && custom.settings.team.value === user.department.toString()
                              || custom.settings.visibility.value === 3 && custom.settings.team && custom.settings.team.value === user.email
                              || custom.settings.visibility.value === 3 && custom.settings.team && custom.settings.team.value === user._id.toString() 
                              || custom.settings.visibility.value === 3 && custom.settings.emailUsers.filter(u => u.email === user.email).length > 0 ? (
                                <NotificationCheckin
                                  msg={customTxt}
                                  cta={copy.liveCta}
                                  type={5}
                                  icon={icons.clipboard}
                                  btnColor={'green'}
                                  color={`green`}
                                  url={`/campaign/create/${custom.settings._id}`}
                                  styles={'mr-25'}
                                />
                              ) : null}
                          </Fragment>
                        ) : null}

                    {icebreakers && icebreakers.length > 0 && icebreakers[0].answers.length === 0 ||
                          icebreakers && user && icebreakers.length > 0 && icebreakers[0].answers.length > 0 && 
                          icebreakers[0].answers.filter(item => item.user.toString() === user._id.toString()).length === 0 ?
                        (
                          <NotificationIcebreaker
                            msg={icebreakers[0].question}
                            icebreakerID={icebreakers[0]._id}
                            styles={'mr-25'}
                            user={user}
                            addIcebreakerAnswer={addIcebreakerAnswer}
                          />
                        ) : null}
                    </div>

                    <div className="mt-4 mb-5">
                      <SubMenu
                        items={menu && menu.menuArr ? menu.menuArr : []}
                        activeIndex={menuIndex}
                        mb={'5'}
                      />
                    </div>

                    <div className="flex space-between align-center flex-column-xs">
                      <FormattedMessage
                        id="checkins.sub_menu.teamSelect"
                        defaultMessage="Choose the team or user"
                      >
                        {msg => (
                          <Select
                            className="small-input w-350px w-100-xs"
                            defaultValue={choosedTeam}
                            value={team}
                            onChange={selectedOption =>
                              handleTeam(selectedOption)
                            }
                            options={teamOptions}
                            isSearchable
                            placeholder={msg}
                            required
                            name="team"
                            styles={customStyles}
                          />
                        )}
                      </FormattedMessage>

                      <FormattedMessage
                        id="focus.sub_menu.timeSelect"
                        defaultMessage="Choose the time interval"
                      >
                        {msg => (
                          <Select
                            className="small-input w-350px w-100-xs"
                            defaultValue={choosedTime}
                            value={time}
                            onChange={selectedOption =>
                              handleTime(selectedOption)
                            }
                            options={timeOptions}
                            // isSearchable
                            placeholder={msg}
                            required
                            name="time"
                            styles={customStyles}
                          />
                        )}
                      </FormattedMessage>  
                    </div>
                  </div>


                  {user.isAdmin || !custom || custom && !custom.settings || !custom.settings.visibility || custom.settings.visibility.value === 1 
                    || custom.settings.visibility.value === 2 && user.department && custom.settings.team && custom.settings.team.value === user.department.toString()
                    || custom.settings.visibility.value === 3 && custom.settings.team && custom.settings.team.value === user.email
                    || custom.settings.visibility.value === 3 && custom.settings.team && custom.settings.team.value === user._id.toString() 
                    || custom.settings.visibility.value === 3 && custom.settings.emailUsers.filter(u => u.email === user.email).length > 0 ? (
                      <div className="dashboard__body flex align-start mt-4">
                        <div className="dashboard__body_left mr-3">
                          <WidgetsDashboard 
                              bgColor={'light'}
                              widgetsAmount={4}
                              width={24}
                              widgetData={widgetData}
                              board={5}
                            />
    
                          <div className="checkins">
                            <div className="checkins__title flex align-center mt-25 mb-3">
                              <p className="fs-22 bold">{latestCheckins}</p>
                              <Link
                                to={`/campaigns/${custom && custom.settings && custom.settings._id ? custom.settings._id : 'all-checkins'}`}
                                className="fs-12 blue cursor bold mla mb-0"
                              >
                                {viewCheckins}
                              </Link>
                            </div>
                            {lastFiveAnswers.length > 0 && (
                              lastFiveAnswers.map((item, index) => (
                              <div className="p-2 br-4 mb-14 brd brd-grey__light bg__white" key={index}>
                                <div className="cards">
                                  {/* <CheckinItemCard
                                    standupAnswer={item}
                                    key={`team-${item._id}-${index}`}
                                    standupDate={item}
                                  /> */}
                                  <PlanItemCard
                                    planAnswer={item}
                                    key={`team-${item._id}-${index}`}
                                    formData={formData}
                                    setFormData={setFormData}
                                    auth={user && user._id}
                                    settingsID={settings && settings.planID}
                                    isHideLikesAndComments={true}
                                  />
                                </div>
                              </div>
                              ))
                            )}
                          </div>
    
                          <div className="answers">
                            <h3 className="fs-2 pt-25 pl-2 pb-1">{completedAnswersTitle}</h3>
                            <Table
                              answers={uniqueAnswers.length > 0 && uniqueAnswers}
                              getUserAnswersAmount={getUserAnswersAmount}
                              tableNameTitle={tableNameTitle}
                              tableTitleItems={tableTitleItems}
                              noContentMsg={noAnswersMsg}
                              isUnfinishedUsers={false}
                              campaigns={campaignsArr}
                              profiles={profiles}
                              linkName={''}
                            />
                          </div>
                        </div>
    
                        <div className="dashboard__body_right">
                          <div className="no-answers">
                            <NotAnsweredTable
                              answers={notCompletedAnswers}
                              linkName={''}
                              standupAnswers={customAnswers}
                              type={4}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="mt-2 pt-xs mb-5">
                        <p className="fs-16">{noAccess}</p>
                      </div>
                    )}
                </div>
              </Fragment>
            )}
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
};

DashboardCustoms.propTypes = {
  getCompanyProfiles: PropTypes.func.isRequired,
  getUserCompany: PropTypes.func.isRequired,
  getCompanyPlanAnswers: PropTypes.func.isRequired,
  getPlanSettings: PropTypes.func.isRequired,
  getAllCustoms: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  planAnswer: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  custom: PropTypes.object.isRequired,
  getUserUpdateAnswers: PropTypes.func.isRequired,
  getUpdates: PropTypes.func.isRequired,
  getIcebreakers: PropTypes.func.isRequired,
  getUserPlanAnswers: PropTypes.func.isRequired,
  getPlanSettings: PropTypes.func.isRequired,
  addIcebreakerAnswer: PropTypes.func.isRequired,
  getCompanyCustomAnswersById: PropTypes.func.isRequired,
  getCustomSettings: PropTypes.func.isRequired,
  standupAnswer: PropTypes.object.isRequired,
  standup: PropTypes.object.isRequired,
  icebreaker: PropTypes.object.isRequired,
  update: PropTypes.object.isRequired,
  updateAnswer: PropTypes.object.isRequired,
  customAnswer: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  locale: state.locale,
  company: state.company,
  profile: state.profile,
  planAnswer: state.planAnswer,
  plan: state.plan,
  custom: state.custom,
  update: state.update,
  updateAnswer: state.updateAnswer,
  icebreaker: state.icebreaker,
  standupAnswer: state.standupAnswer,
  customAnswer: state.customAnswer,
  standup: state.standup,
});

export default connect(
  mapStateToProps,
  {
    getUserCompany, getCompanyProfiles, getCompanyPlanAnswers,
    getPlanSettings, getAllCustoms,
    getUserUpdateAnswers,
    getUpdates, getIcebreakers, 
    addIcebreakerAnswer, getUserAnswers, getStandups,
    getCompanyCustomAnswersById,
    getCustomSettings,
  }
)(DashboardCustoms);
